<template>
  <div class="row">
    <div class="col-12">
      <div class="top__header">
        <span class="back" @click="back()">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.7071 5.79289C16.0976 6.18342 16.0976 6.81658 15.7071 7.20711L10.4142 12.5L15.7071 17.7929C16.0976 18.1834 16.0976 18.8166 15.7071 19.2071C15.3166 19.5976 14.6834 19.5976 14.2929 19.2071L8.29289 13.2071C7.90237 12.8166 7.90237 12.1834 8.29289 11.7929L14.2929 5.79289C14.6834 5.40237 15.3166 5.40237 15.7071 5.79289Z"
              fill="black"
            />
          </svg>
        </span>
        <div>
          <span style="font-weight: bold; font-size: 16px"
            >Assurance voyage</span
          >
          <span v-if="status === 'add'" class="badge badge-pill badge-info"
            >Paiement à la livraison</span
          >
          <span
            v-if="
              status === 'negotiated' && subscription.amount_negotiated !== null
            "
            class="badge badge-pill badge-info"
            >Négocié</span
          >
          <span v-if="status === 'paid'" class="badge badge-pill badge-success"
            >Payé</span
          >
          <span
            v-if="
              status === 'negotiated' && subscription.amount_negotiated === null
            "
            class="badge badge-pill badge-info"
            >En négociation</span
          >
        </div>
        <div style="place-self: end">
          <button
            @click="enCharge"
            class="btn btn-secondary btn-xs"
            v-if="status === 'add' && treat_by == null && connected!=3"
          >
            Prendre en charge
          </button>
          <button
            @click="showComments"
            class="btn btn-secondary btn-xs"
            v-if="
              status === 'negotiated' && subscription.amount_negotiated === null
              && connected!=3
            "
          >
            Rentrer en contact avec le client
          </button>
          <button
            @click="validatePayment"
            class="btn btn-primary"
            v-if="status === 'add' && treat_by == null && connected!=3"
          >
            Valider le paiement
          </button>
          <button
            @click="showModal"
            v-if="
              (status === 'negotiated' &&
                subscription.amount_negotiated === null && connected!=3) ||
              (status === 'negotiated' &&
                subscription.amount_negotiated !== null && connected!=3)
            "
            class="btn btn-primary"
          >
            Appliquer une réduction
          </button>
        </div>
      </div>
      <div class="card__info">
        <h4>Informations client</h4>
        <div class="__first">
          <div>
            <div><strong>Nom</strong></div>
            <span>{{
              subscription.data.client_name || subscription.data.last_name || (subscription.user ? subscription.user.last_name : "")
            }}</span>
          </div>
          <div>
            <div><strong>Prénom(s)</strong></div>
            <span>{{
              subscription.data.client_firstname || subscription.data.first_name || (subscription.user ? subscription.user.first_name : "")
            }}</span>
          </div>
          <div>
            <div><strong>Téléphone</strong></div>
            <span>{{ subscription.user ? subscription.user.phone : "" }}</span>
          </div>
        </div>
        <div class="__first mt-2">
          <div>
            <div><strong>Email</strong></div>
            <span>{{ subscription.data.client_email || subscription.data.email || (subscription.user ? subscription.user.email : "") }}</span>
          </div>
          <div>
            <div><strong>Adresse</strong></div>
            <span>{{
              (subscription.user ? subscription.user.address : "") || (subscription.data ? subscription.data.address : "")
            }}</span>
          </div>
          <div>
            <div><strong>Personne à contacter en cas d’urgence</strong></div>
            <span>
              {{
                (subscription.user ? subscription.user.contact_person_full_name : "") || (subscription.data ? subscription.data.contact_person_full_name : "")
              }}
              {{
                (subscription.user ? subscription.user.contact_person_number : "") || (subscription.data ? subscription.data.contact_person_number : "")
                  ? " (" + ((subscription.user ? subscription.user.contact_person_number : "") || (subscription.data ? subscription.data.contact_person_number : "")) + ")"
                  : ""
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="card__info mt-2">
        <h4>Informations de souscription</h4>
        <div class="__first">
          <div>
            <div><strong>Produit</strong></div>
            <span>{{
              subscription.product ? subscription.product.name : ""
            }}</span>
          </div>
          <div>
            <div><strong>Détail du montant (Fcfa)</strong></div>
            <div v-if="subscription.data && subscription.data.pricing">
              <div class="small">Prime nette: {{ $format(subscription.data.pricing.net) }}</div>
              <div class="small">Taxes: {{ $format(subscription.data.pricing.tax) }}</div>
              <div class="small">Frais de dossier: {{ $format(subscription.data.pricing.fees) }}</div>
              <div class="font-weight-bold">Total: {{ $format(subscription.amount) }}</div>
            </div>
            <span v-else>{{ subscription ? $format(subscription.amount) : "" }}</span>
          </div>
          <div>
            <div><strong>Date de souscription</strong></div>
            <span>{{ subscription ? subscription.created_at : "" }}</span>
          </div>
        </div>
      </div>
      <div class="card__info mt-2">
        <h4>Formulaire de souscription</h4>
        <div class="mt-2" v-if="subscription.data.other_people && subscription.data.other_people.length > 0">
          <svg
            width="174"
            height="36"
            viewBox="0 0 174 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="174" height="36" rx="16" fill="#F3F2F7" />
            <path
              d="M15.5879 21.0923C15.5879 22.0444 15.2437 22.7915 14.5552 23.3335C13.8667 23.8755 12.917 24.1465 11.7061 24.1465C10.4951 24.1465 9.50391 23.9585 8.73242 23.5825V21.9272C9.2207 22.1567 9.73828 22.3374 10.2852 22.4692C10.8369 22.6011 11.3496 22.667 11.8232 22.667C12.5166 22.667 13.0269 22.5352 13.354 22.2715C13.686 22.0078 13.8521 21.6538 13.8521 21.2095C13.8521 20.8091 13.7007 20.4697 13.3979 20.1914C13.0952 19.9131 12.4702 19.5835 11.5229 19.2026C10.5464 18.8071 9.85791 18.3555 9.45752 17.8477C9.05713 17.3398 8.85693 16.7295 8.85693 16.0166C8.85693 15.123 9.17432 14.4199 9.80908 13.9072C10.4438 13.3945 11.2959 13.1382 12.3652 13.1382C13.3906 13.1382 14.4111 13.3628 15.4268 13.812L14.8701 15.2402C13.918 14.8398 13.0684 14.6396 12.3213 14.6396C11.7549 14.6396 11.3252 14.7642 11.0322 15.0132C10.7393 15.2573 10.5928 15.582 10.5928 15.9873C10.5928 16.2656 10.6514 16.5049 10.7686 16.7051C10.8857 16.9004 11.0786 17.0859 11.3472 17.2617C11.6157 17.4375 12.0991 17.6694 12.7974 17.9575C13.5835 18.2847 14.1597 18.5898 14.5259 18.873C14.8921 19.1562 15.1606 19.4761 15.3315 19.8325C15.5024 20.189 15.5879 20.6089 15.5879 21.0923ZM24.1626 19.9351C24.1626 21.2583 23.8232 22.291 23.1445 23.0332C22.4658 23.7754 21.521 24.1465 20.3101 24.1465C19.5532 24.1465 18.8843 23.9756 18.3032 23.6338C17.7222 23.292 17.2754 22.8013 16.9629 22.1616C16.6504 21.522 16.4941 20.7798 16.4941 19.9351C16.4941 18.6216 16.8311 17.5962 17.5049 16.8589C18.1787 16.1216 19.1284 15.7529 20.354 15.7529C21.5259 15.7529 22.4536 16.1313 23.1372 16.8882C23.8208 17.6401 24.1626 18.6558 24.1626 19.9351ZM18.2666 19.9351C18.2666 21.8052 18.9575 22.7402 20.3394 22.7402C21.7065 22.7402 22.3901 21.8052 22.3901 19.9351C22.3901 18.0845 21.7017 17.1592 20.3247 17.1592C19.6021 17.1592 19.0771 17.3984 18.75 17.877C18.4277 18.3555 18.2666 19.0415 18.2666 19.9351ZM31.3604 24L31.1187 22.938H31.0308C30.7915 23.314 30.4497 23.6094 30.0054 23.8242C29.5659 24.0391 29.063 24.1465 28.4966 24.1465C27.5151 24.1465 26.7827 23.9023 26.2993 23.4141C25.8159 22.9258 25.5742 22.186 25.5742 21.1948V15.8994H27.3101V20.8945C27.3101 21.5146 27.437 21.981 27.6909 22.2935C27.9448 22.6011 28.3428 22.7549 28.8848 22.7549C29.6074 22.7549 30.1372 22.54 30.4741 22.1104C30.8159 21.6758 30.9868 20.9507 30.9868 19.9351V15.8994H32.7153V24H31.3604ZM40.1108 21.6929C40.1108 22.4839 39.8228 23.0918 39.2466 23.5166C38.6704 23.9365 37.8452 24.1465 36.771 24.1465C35.6919 24.1465 34.8252 23.9829 34.1709 23.6558V22.1689C35.123 22.6084 36.0093 22.8281 36.8296 22.8281C37.8892 22.8281 38.4189 22.5083 38.4189 21.8687C38.4189 21.6636 38.3604 21.4927 38.2432 21.356C38.126 21.2192 37.9331 21.0776 37.6646 20.9312C37.396 20.7847 37.0225 20.6187 36.5439 20.4331C35.6113 20.0718 34.979 19.7104 34.647 19.3491C34.3198 18.9878 34.1562 18.519 34.1562 17.9429C34.1562 17.2495 34.4346 16.7124 34.9912 16.3315C35.5527 15.9458 36.3145 15.7529 37.2764 15.7529C38.2285 15.7529 39.1294 15.9458 39.979 16.3315L39.4224 17.6279C38.5483 17.2666 37.8135 17.0859 37.2178 17.0859C36.3096 17.0859 35.8555 17.3447 35.8555 17.8623C35.8555 18.1162 35.9727 18.3311 36.207 18.5068C36.4463 18.6826 36.9639 18.9243 37.7598 19.2319C38.4287 19.4907 38.9146 19.7275 39.2173 19.9424C39.52 20.1572 39.7446 20.4062 39.8911 20.6895C40.0376 20.9678 40.1108 21.3022 40.1108 21.6929ZM44.7451 24.1465C43.5195 24.1465 42.5869 23.79 41.9473 23.0771C41.3125 22.3594 40.9951 21.3315 40.9951 19.9937C40.9951 18.6313 41.3271 17.584 41.9912 16.8516C42.6602 16.1191 43.6245 15.7529 44.8843 15.7529C45.7388 15.7529 46.5078 15.9116 47.1914 16.229L46.6714 17.6133C45.9438 17.3301 45.3433 17.1885 44.8696 17.1885C43.4683 17.1885 42.7676 18.1187 42.7676 19.979C42.7676 20.8872 42.9409 21.5708 43.2876 22.0298C43.6392 22.4839 44.1519 22.7109 44.8257 22.7109C45.5923 22.7109 46.3174 22.5205 47.001 22.1396V23.6411C46.6934 23.8218 46.3638 23.9512 46.0122 24.0293C45.6655 24.1074 45.2432 24.1465 44.7451 24.1465ZM52.5142 15.7529C52.8608 15.7529 53.1465 15.7773 53.3711 15.8262L53.2026 17.4302C52.9585 17.3716 52.7046 17.3423 52.4409 17.3423C51.7524 17.3423 51.1934 17.5669 50.7637 18.0161C50.3389 18.4653 50.1265 19.0488 50.1265 19.7666V24H48.4053V15.8994H49.7529L49.98 17.3276H50.0679C50.3364 16.8442 50.6855 16.4609 51.1152 16.1777C51.5498 15.8945 52.0161 15.7529 52.5142 15.7529ZM56.1011 24H54.3799V15.8994H56.1011V24ZM54.2773 13.7534C54.2773 13.4458 54.3604 13.209 54.5264 13.043C54.6973 12.877 54.939 12.7939 55.2515 12.7939C55.5542 12.7939 55.7886 12.877 55.9546 13.043C56.1255 13.209 56.2109 13.4458 56.2109 13.7534C56.2109 14.0464 56.1255 14.2783 55.9546 14.4492C55.7886 14.6152 55.5542 14.6982 55.2515 14.6982C54.939 14.6982 54.6973 14.6152 54.5264 14.4492C54.3604 14.2783 54.2773 14.0464 54.2773 13.7534ZM62.1782 24.1465C61.1528 24.1465 60.3569 23.7778 59.7905 23.0405H59.688C59.7563 23.7241 59.7905 24.1392 59.7905 24.2856V27.6035H58.0693V15.8994H59.4609C59.5 16.0508 59.5806 16.4121 59.7026 16.9834H59.7905C60.3276 16.1631 61.1333 15.7529 62.2075 15.7529C63.2183 15.7529 64.0044 16.1191 64.5659 16.8516C65.1323 17.584 65.4155 18.6118 65.4155 19.9351C65.4155 21.2583 65.1274 22.291 64.5513 23.0332C63.98 23.7754 63.189 24.1465 62.1782 24.1465ZM61.7607 17.1592C61.0771 17.1592 60.5767 17.3594 60.2593 17.7598C59.9468 18.1602 59.7905 18.7998 59.7905 19.6787V19.9351C59.7905 20.9214 59.9468 21.6367 60.2593 22.0811C60.5718 22.5205 61.082 22.7402 61.79 22.7402C62.3857 22.7402 62.8447 22.4961 63.167 22.0078C63.4893 21.5195 63.6504 20.8237 63.6504 19.9204C63.6504 19.0122 63.4893 18.3262 63.167 17.8623C62.8496 17.3936 62.3809 17.1592 61.7607 17.1592ZM69.9326 22.7549C70.3525 22.7549 70.7725 22.689 71.1924 22.5571V23.8535C71.002 23.9365 70.7554 24.0049 70.4526 24.0586C70.1548 24.1172 69.8447 24.1465 69.5225 24.1465C67.8916 24.1465 67.0762 23.2871 67.0762 21.5684V17.2031H65.9702V16.4414L67.1567 15.8115L67.7427 14.0977H68.8047V15.8994H71.1118V17.2031H68.8047V21.5391C68.8047 21.9541 68.9072 22.2617 69.1123 22.4619C69.3223 22.6572 69.5957 22.7549 69.9326 22.7549ZM74.0396 24H72.3184V15.8994H74.0396V24ZM72.2158 13.7534C72.2158 13.4458 72.2988 13.209 72.4648 13.043C72.6357 12.877 72.8774 12.7939 73.1899 12.7939C73.4927 12.7939 73.7271 12.877 73.8931 13.043C74.064 13.209 74.1494 13.4458 74.1494 13.7534C74.1494 14.0464 74.064 14.2783 73.8931 14.4492C73.7271 14.6152 73.4927 14.6982 73.1899 14.6982C72.8774 14.6982 72.6357 14.6152 72.4648 14.4492C72.2988 14.2783 72.2158 14.0464 72.2158 13.7534ZM83.1929 19.9351C83.1929 21.2583 82.8535 22.291 82.1748 23.0332C81.4961 23.7754 80.5513 24.1465 79.3403 24.1465C78.5835 24.1465 77.9146 23.9756 77.3335 23.6338C76.7524 23.292 76.3057 22.8013 75.9932 22.1616C75.6807 21.522 75.5244 20.7798 75.5244 19.9351C75.5244 18.6216 75.8613 17.5962 76.5352 16.8589C77.209 16.1216 78.1587 15.7529 79.3843 15.7529C80.5562 15.7529 81.4839 16.1313 82.1675 16.8882C82.8511 17.6401 83.1929 18.6558 83.1929 19.9351ZM77.2969 19.9351C77.2969 21.8052 77.9878 22.7402 79.3696 22.7402C80.7368 22.7402 81.4204 21.8052 81.4204 19.9351C81.4204 18.0845 80.7319 17.1592 79.355 17.1592C78.6323 17.1592 78.1074 17.3984 77.7803 17.877C77.458 18.3555 77.2969 19.0415 77.2969 19.9351ZM91.8042 24H90.0757V19.0195C90.0757 18.3945 89.9487 17.9282 89.6948 17.6206C89.4458 17.313 89.0479 17.1592 88.501 17.1592C87.7734 17.1592 87.2412 17.374 86.9043 17.8037C86.5674 18.2334 86.3989 18.9536 86.3989 19.9644V24H84.6777V15.8994H86.0254L86.2671 16.9614H86.355C86.5991 16.5757 86.9458 16.2778 87.395 16.0679C87.8442 15.8579 88.3423 15.7529 88.8892 15.7529C90.8325 15.7529 91.8042 16.7417 91.8042 18.7192V24ZM99.8276 24.1465C98.8169 24.1465 98.0283 23.7803 97.4619 23.0479C96.8955 22.3154 96.6123 21.2876 96.6123 19.9644C96.6123 18.6362 96.8979 17.6035 97.4692 16.8662C98.0454 16.124 98.8413 15.7529 99.8569 15.7529C100.921 15.7529 101.732 16.146 102.289 16.9321H102.376C102.293 16.3511 102.252 15.8921 102.252 15.5552V12.6035H103.98V24H102.633L102.333 22.938H102.252C101.7 23.7437 100.892 24.1465 99.8276 24.1465ZM100.289 22.7549C100.997 22.7549 101.512 22.5571 101.834 22.1616C102.157 21.7612 102.323 21.1143 102.333 20.2207V19.979C102.333 18.9585 102.167 18.2334 101.834 17.8037C101.502 17.374 100.982 17.1592 100.274 17.1592C99.6689 17.1592 99.2026 17.4058 98.8755 17.8989C98.5483 18.3872 98.3848 19.0854 98.3848 19.9937C98.3848 20.8921 98.5435 21.5781 98.8608 22.0518C99.1782 22.5205 99.6543 22.7549 100.289 22.7549ZM109.479 24.1465C108.219 24.1465 107.233 23.7803 106.52 23.0479C105.812 22.3105 105.458 21.2974 105.458 20.0083C105.458 18.6851 105.788 17.645 106.447 16.8882C107.106 16.1313 108.012 15.7529 109.164 15.7529C110.233 15.7529 111.078 16.0776 111.698 16.7271C112.318 17.3765 112.628 18.27 112.628 19.4077V20.3379H107.23C107.255 21.124 107.467 21.7295 107.868 22.1543C108.268 22.5742 108.832 22.7842 109.56 22.7842C110.038 22.7842 110.482 22.7402 110.893 22.6523C111.308 22.5596 111.752 22.4082 112.226 22.1982V23.5972C111.806 23.7974 111.381 23.939 110.951 24.022C110.521 24.105 110.031 24.1465 109.479 24.1465ZM109.164 17.0566C108.617 17.0566 108.178 17.23 107.846 17.5767C107.519 17.9233 107.323 18.4287 107.26 19.0928H110.937C110.927 18.4238 110.766 17.9185 110.453 17.5767C110.141 17.23 109.711 17.0566 109.164 17.0566ZM124.321 15.8994V16.8442L122.937 17.1006C123.064 17.2715 123.169 17.4814 123.252 17.7305C123.335 17.9795 123.376 18.2432 123.376 18.5215C123.376 19.3564 123.088 20.0132 122.512 20.4917C121.936 20.9702 121.143 21.2095 120.132 21.2095C119.873 21.2095 119.639 21.1899 119.429 21.1509C119.058 21.3804 118.872 21.6489 118.872 21.9565C118.872 22.1421 118.958 22.2812 119.128 22.374C119.304 22.4668 119.624 22.5132 120.088 22.5132H121.501C122.395 22.5132 123.074 22.7036 123.538 23.0845C124.001 23.4653 124.233 24.0146 124.233 24.7324C124.233 25.6504 123.855 26.3584 123.098 26.8564C122.341 27.3545 121.248 27.6035 119.817 27.6035C118.713 27.6035 117.871 27.4082 117.29 27.0176C116.709 26.627 116.418 26.0703 116.418 25.3477C116.418 24.8496 116.575 24.4297 116.887 24.0879C117.205 23.751 117.646 23.5166 118.213 23.3848C117.983 23.2871 117.793 23.1309 117.642 22.916C117.495 22.6963 117.422 22.4668 117.422 22.2275C117.422 21.9248 117.507 21.6685 117.678 21.4585C117.849 21.2485 118.103 21.041 118.44 20.8359C118.02 20.6553 117.678 20.3623 117.415 19.957C117.156 19.5469 117.026 19.0684 117.026 18.5215C117.026 17.6426 117.302 16.9614 117.854 16.478C118.411 15.9946 119.202 15.7529 120.227 15.7529C120.457 15.7529 120.696 15.77 120.945 15.8042C121.199 15.8335 121.389 15.8652 121.516 15.8994H124.321ZM117.957 25.2598C117.957 25.6309 118.123 25.9165 118.455 26.1167C118.792 26.3169 119.263 26.417 119.868 26.417C120.806 26.417 121.504 26.2827 121.963 26.0142C122.422 25.7456 122.651 25.3892 122.651 24.9448C122.651 24.5933 122.524 24.3418 122.271 24.1904C122.021 24.0439 121.555 23.9707 120.872 23.9707H119.568C119.075 23.9707 118.682 24.0854 118.389 24.3149C118.101 24.5493 117.957 24.8643 117.957 25.2598ZM118.696 18.5215C118.696 19.0293 118.826 19.4199 119.084 19.6934C119.348 19.9668 119.724 20.1035 120.212 20.1035C121.208 20.1035 121.707 19.5713 121.707 18.5068C121.707 17.9795 121.582 17.5742 121.333 17.291C121.089 17.0029 120.715 16.8589 120.212 16.8589C119.714 16.8589 119.336 17.0005 119.077 17.2837C118.823 17.5669 118.696 17.9795 118.696 18.5215ZM129.439 15.7529C129.786 15.7529 130.071 15.7773 130.296 15.8262L130.127 17.4302C129.883 17.3716 129.629 17.3423 129.366 17.3423C128.677 17.3423 128.118 17.5669 127.688 18.0161C127.264 18.4653 127.051 19.0488 127.051 19.7666V24H125.33V15.8994H126.678L126.905 17.3276H126.993C127.261 16.8442 127.61 16.4609 128.04 16.1777C128.475 15.8945 128.941 15.7529 129.439 15.7529ZM138.49 19.9351C138.49 21.2583 138.15 22.291 137.472 23.0332C136.793 23.7754 135.848 24.1465 134.637 24.1465C133.88 24.1465 133.211 23.9756 132.63 23.6338C132.049 23.292 131.603 22.8013 131.29 22.1616C130.978 21.522 130.821 20.7798 130.821 19.9351C130.821 18.6216 131.158 17.5962 131.832 16.8589C132.506 16.1216 133.456 15.7529 134.681 15.7529C135.853 15.7529 136.781 16.1313 137.464 16.8882C138.148 17.6401 138.49 18.6558 138.49 19.9351ZM132.594 19.9351C132.594 21.8052 133.285 22.7402 134.667 22.7402C136.034 22.7402 136.717 21.8052 136.717 19.9351C136.717 18.0845 136.029 17.1592 134.652 17.1592C133.929 17.1592 133.404 17.3984 133.077 17.877C132.755 18.3555 132.594 19.0415 132.594 19.9351ZM145.688 24L145.446 22.938H145.358C145.119 23.314 144.777 23.6094 144.333 23.8242C143.893 24.0391 143.39 24.1465 142.824 24.1465C141.842 24.1465 141.11 23.9023 140.626 23.4141C140.143 22.9258 139.901 22.186 139.901 21.1948V15.8994H141.637V20.8945C141.637 21.5146 141.764 21.981 142.018 22.2935C142.272 22.6011 142.67 22.7549 143.212 22.7549C143.935 22.7549 144.464 22.54 144.801 22.1104C145.143 21.6758 145.314 20.9507 145.314 19.9351V15.8994H147.042V24H145.688ZM153.105 24.1465C152.08 24.1465 151.284 23.7778 150.717 23.0405H150.615C150.683 23.7241 150.717 24.1392 150.717 24.2856V27.6035H148.996V15.8994H150.388C150.427 16.0508 150.507 16.4121 150.629 16.9834H150.717C151.254 16.1631 152.06 15.7529 153.134 15.7529C154.145 15.7529 154.931 16.1191 155.493 16.8516C156.059 17.584 156.342 18.6118 156.342 19.9351C156.342 21.2583 156.054 22.291 155.478 23.0332C154.907 23.7754 154.116 24.1465 153.105 24.1465ZM152.688 17.1592C152.004 17.1592 151.503 17.3594 151.186 17.7598C150.874 18.1602 150.717 18.7998 150.717 19.6787V19.9351C150.717 20.9214 150.874 21.6367 151.186 22.0811C151.499 22.5205 152.009 22.7402 152.717 22.7402C153.312 22.7402 153.771 22.4961 154.094 22.0078C154.416 21.5195 154.577 20.8237 154.577 19.9204C154.577 19.0122 154.416 18.3262 154.094 17.8623C153.776 17.3936 153.308 17.1592 152.688 17.1592ZM161.379 24.1465C160.12 24.1465 159.133 23.7803 158.42 23.0479C157.712 22.3105 157.358 21.2974 157.358 20.0083C157.358 18.6851 157.688 17.645 158.347 16.8882C159.006 16.1313 159.912 15.7529 161.064 15.7529C162.134 15.7529 162.979 16.0776 163.599 16.7271C164.219 17.3765 164.529 18.27 164.529 19.4077V20.3379H159.131C159.155 21.124 159.368 21.7295 159.768 22.1543C160.168 22.5742 160.732 22.7842 161.46 22.7842C161.938 22.7842 162.383 22.7402 162.793 22.6523C163.208 22.5596 163.652 22.4082 164.126 22.1982V23.5972C163.706 23.7974 163.281 23.939 162.852 24.022C162.422 24.105 161.931 24.1465 161.379 24.1465ZM161.064 17.0566C160.518 17.0566 160.078 17.23 159.746 17.5767C159.419 17.9233 159.224 18.4287 159.16 19.0928H162.837C162.827 18.4238 162.666 17.9185 162.354 17.5767C162.041 17.23 161.611 17.0566 161.064 17.0566Z"
              fill="#5E5873"
            />
          </svg>
        </div>
        <div class="__first mt-2">
          <div>
            <div><strong>Nom</strong></div>
            <span>{{ subscription.data.last_name }}</span>
          </div>
          <div>
            <div><strong>Prénom(s)</strong></div>
            <span>{{ subscription.data.first_name }}</span>
          </div>
          <div>
            <div><strong>N° de passeport</strong></div>
            <span>{{ subscription.data.passport_number }}</span>
          </div>
        </div>
        <div class="__first mt-2">
          <div>
            <div><strong>Date de naissance</strong></div>
            <span>{{ subscription.data.date_nais ? subscription.data.date_nais.toString().split("-").reverse().join("-") : '' }}</span>
          </div>
          <div>
            <div><strong>Date de départ</strong></div>
            <span>{{ subscription.data.date_begin ? subscription.data.date_begin.toString().split("-").reverse().join("-") : '' }}</span>
          </div>
          <div>
            <div><strong>Date de retour</strong></div>
            <span>{{ subscription.data.date_end ? subscription.data.date_end.toString().split("-").reverse().join("-") : '' }}</span>
          </div>
        </div>
        <div class="__first mt-2">
          <div>
            <div><strong>Tranche d'âge</strong></div>
            <span>{{ subscription.data.birthday }}</span>
          </div>
          <div>
            <div><strong>Zone de destination</strong></div>
            <span>{{ subscription.data.destination_area }}</span>
          </div>
          <div>
            <div><strong>Durée du voyage (jours)</strong></div>
            <span>{{ subscription.data.travel_time }}</span>
          </div>
        </div>
        <div v-for="(item, key) in subscription.data.other_people" :key="key">
          <hr />
          <div class="__first mt-2">
            <div>
              <div><strong>Nom</strong></div>
              <span>{{ item.last_name }}</span>
            </div>
            <div>
              <div><strong>Prénom(s)</strong></div>
              <span>{{ item.first_name }}</span>
            </div>
            <div>
              <div><strong>N° de passeport</strong></div>
              <span>{{ item.passport_number }}</span>
            </div>
          </div>
          <div class="__first mt-2">
            <div>
              <div><strong>Date de naissance</strong></div>
              <span>{{ item.date_nais ? item.date_nais.toString().split("-").reverse().join("-") : '' }}</span>
            </div>
            <div>
              <div><strong>Date de départ</strong></div>
              <span>{{ item.date_begin ? item.date_begin.toString().split("-").reverse().join("-") : '' }}</span>
            </div>
            <div>
              <div><strong>Date de retour</strong></div>
              <span>{{ item.date_end ? item.date_end.toString().split("-").reverse().join("-") : '' }}</span>
            </div>
          </div>
          <div class="__first mt-2">
            <div>
              <div><strong>Tranche d'âge</strong></div>
              <span>{{ item.birthday }}</span>
            </div>
            <div>
              <div><strong>Zone de destination</strong></div>
              <span>{{ item.destination_area }}</span>
            </div>
            <div>
              <div><strong>Durée du voyage (jours)</strong></div>
              <span>{{ item.travel_time }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="subscription.files != null && subscription.files.length > 0"
        class="card__info mt-2"
      >
        <h4>Fichiers joints</h4>
        <div class="mt-2">
          <div class="row">
            <div
              v-for="(item, key) in subscription.files"
              :key="key"
              class="col-md-4"
            >
              <a class="file" download :href="item.url">{{ item.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade text-left"
      id="negociation"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel1"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">
              Appliquer une réduction
            </h4>
            <button
              @click="errors = []"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Montant de la réduction (FCFA)</label>
              <input
                v-model="form.montant"
                class="form-control"
                type="number"
              />
              <div v-if="errors.montant" style="color: red">
                {{ errors.montant[0] }}
              </div>
            </div>
            <div class="info_badge mt-1 mb-1">
              <span
                >Le nouveau montant de la souscription est :
                <strong>{{ reduction }} FCFA</strong></span
              >
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  :class="loading || errors.length > 0 ? 'disabled' : ''"
                  @click="applyReduction()"
                  type="button"
                  class="btn btn-primary btn-block"
                >
                  Appliquer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="comments"
      tabindex="-1"
      role="dialog"
      aria-labelledby="comments"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #fff !important">
            <h5 class="modal-title" id="comments">
              Négociation de l'assurance auto n° {{ subscription.id }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #f8f8f8 !important">
            <div class="chat-box">
              <div
                :class="!comment.is_customer ? 'chat' : 'chat-left'"
                class="mb-2"
                v-for="(comment, key) in comments"
                :key="key"
              >
                {{ comment.message }}
              </div>
            </div>
          </div>
          <div class="modal-footer grid-item">
            <input
              @keyup.enter="sendComment"
              :class="sending ? 'error' : ''"
              v-model="comment.message"
              type="text"
              class="form-control message"
              placeholder="Tapez votre message"
            />
            <button @click="sendComment" type="button" class="btn btn-primary">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade text-left"
      id="negociation"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel1"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">
              Appliquer une réduction
            </h4>
            <button
              @click="errors = []"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Montant de la réduction (FCFA)</label>
              <input
                v-model="form.montant"
                class="form-control"
                type="number"
              />
              <div v-if="errors.montant" style="color: red">
                {{ errors.montant[0] }}
              </div>
            </div>
            <div class="info_badge mt-1 mb-1">
              <span
                >Le nouveau montant de la souscription est :
                <strong>{{ reduction }} FCFA</strong></span
              >
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  :class="loading || errors.length > 0 ? 'disabled' : ''"
                  @click="applyReduction()"
                  type="button"
                  class="btn btn-primary btn-block"
                >
                  Appliquer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var $this;
import { api } from "../../../../helpers/shared";
import moment from "moment";
import axios from "axios";
export default {
  props: ["subscription", "user"],
  watch: {
    "form.montant": function (val) {
      if (val != "") {
        if (parseInt(val) < parseInt(this.form.amount)) {
          this.errors = [];
          this.reduction = parseInt(this.form.amount) - parseInt(val);
        } else {
          this.errors = {
            montant: [
              "La réduction est suppérieur au montant de la souscription",
            ],
          };
        }
      } else {
        this.reduction = this.subscription.amount;
        this.errors = { montant: ["Ce champ est obligatoire"] };
      }
    },
  },
  data: () => ({
    treat_by: null,
    form: {
      montant: "",
      amount: "",
      uuid: "",
    },
    status: "",
    reduction: 0,
    errors: [],
    zones: [
      { id: 1, name: "Afrique Europe Moyen-orient" },
      { id: 2, name: "Monde entier" },
      { id: 3, name: "Afrique Europe Moyen-orient" },
      { id: 4, name: "Monde entier" },
    ],
    ages: [
      { id: 1, name: "De 18 à 80 ans" },
      { id: 2, name: "Moins de 18 ans" },
    ],
    loading: false,
    comment: {
      message: "",
      uuid: "",
      id: "",
    },
    sending: false,
    comments: [],
    connected:'',
  }),
  mounted() {
    this.status = this.subscription.status;
    this.form.amount = this.subscription.amount;
    this.reduction = this.subscription.amount;
    this.form.uuid = this.subscription.uuid;
    this.treat_by = this.subscription.treat_by;
    this.connected = this.user.profile;
    if (
      this.status === "negotiated" &&
      this.subscription.amount_negotiated === null
    ) {
      this.getComments();
    }
  },
  created() {
    $this = this;
  },
  methods: {
    enCharge() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#4B4B4B",
        backgroundColor: "#4B4B4B",
        height: 35,
        width: 35,
        loader: "bars",
        opacity: 0.3,
      });
      this.loading = true;
      axios
        .post(api("administration/en-charge"), {
          id: this.subscription.id,
        })
        .then((response) => {
          this.loading = false;
          loader.hide();
          if (response.data.status) {
            this.treat_by = response.data.treat_by;
            this.treat_name = response.data.treat_name;
            this.$toasted.global.all();
          } else {
            this.$toasted.global.error({ message: "Une erreur est survenue" });
          }
        })
        .catch(() => {
          loader.hide();
          this.loading = false;
        });
    },
    showModal() {
      this.errors = [];
      this.form.amount = this.subscription.amount;
      this.reduction = this.subscription.amount;
      this.form.montant = "";
      this.$document("#negociation").modal("show");
    },
    applyReduction() {
      this.loading = true;
      if (this.errors.length === 0) {
        axios
          .post(api("administration/subscription/apply-reduction"), this.form)
          .then((response) => {
            this.loading = false;
            this.errors = [];
            if (response.data.status) {
              this.$document("#negociation").modal("hide");
              this.$toasted.global.all();
              setTimeout(() => {
                window.location.reload();
              }, 300);
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 401) {
            } else {
              this.errors = error.response.data.errors;
            }
          });
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    sendComment() {
      if (this.comment.message != "") {
        this.sending = false;
        this.comment.uuid = this.subscription.uuid;
        this.comment.id = this.subscription.id;
        axios.post(api("subscription/add/message"), this.comment);
        this.comment.message = "";
      } else this.sending = true;
    },
    getComments() {
      db.collection(this.subscription.uuid)
        .orderBy("createdAt")
        .onSnapshot((querySnapshot) => {
          let comments = [];
          querySnapshot.forEach((doc) => {
            comments.push(doc.data());
          });
          this.comments = comments;
        });
    },
    showComments() {
      this.$document("#comments").modal("show");
    },
    validatePayment() {
      $this.$swal
        .fire({
          title: "Êtes-vous sûr de vouloir valider ce paiement ?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Oui, valider",
          cancelButtonText: "Non, annuler",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        })
        .then(function (result) {
          if (result.value) {
            axios
              .post(api("administration/subscription/validate"), {
                id: $this.subscription.id,
                uuid: $this.subscription.uuid,
              })
              .then((response) => {
                $this.$swal.fire({
                  icon: "success",
                  title: "Opération réussie!",
                  text: "",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                $this.status = "paid";
              })
              .catch((error) => {
                if (error.response.status === 401) {
                  this.$toast.global.error({
                    message: "Votre connexion a expiré",
                  });
                } else {
                }
              });
          }
        });
    },
    back() {
      if (window.location.href.includes("/me/")) {
        this.$router("/administration/subscriptions/me");
      } else {
        this.$router("/administration/subscriptions");
      }
    },
    showModal() {
      this.errors = [];
      this.form.amount = this.subscription.amount;
      this.reduction = this.subscription.amount;
      this.form.montant = "";
      this.$document("#negociation").modal("show");
    },
    applyReduction() {
      this.loading = true;
      if (this.errors.length === 0) {
        axios
          .post(api("administration/subscription/apply-reduction"), this.form)
          .then((response) => {
            this.loading = false;
            this.errors = [];
            if (response.data.status) {
              this.$document("#negociation").modal("hide");
              this.$toasted.global.all();
              setTimeout(() => {
                window.location.reload();
              }, 300);
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 401) {
            } else {
              this.errors = error.response.data.errors;
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header__title {
  font-size: 22px;
  line-height: 30px;
  color: #5e5873;
}
.back {
  cursor: pointer;
}
.top__header {
  display: grid;
  grid-template-columns: 30px 1fr 2fr;
  .header__btn {
    justify-self: end;
  }
}
.card__info {
  padding: 20px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  margin-top: 20px;
  .__first {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
.info_badge {
  height: auto;
  padding: 10px;
  width: 100%;
  background: #e8efff;
  border-radius: 24px;
  color: #000;
}
.btn-secondary {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
}

.btn-secondary:focus,
.btn-secondary.focus {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
  box-shadow: 0 0 0 0.2rem #d09a12;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem #d09a12;
}
.grid-item {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 5px;
  padding: 5px;
}
.chat {
  background-color: #fff;
  padding: 10px;
  height: auto;
  width: 80%;
  border-radius: 5px;
}
.chat-left {
  background: linear-gradient(
    46.62deg,
    #001e5f 0%,
    rgba(0, 30, 95, 0.8) 93.64%
  );
  border-radius: 5px;
  color: #fff;
  text-align: right;
  padding: 10px;
  height: auto;
  width: 80%;
  margin-left: 20%;
}
.error {
  border-color: red !important;
}
.file {
  text-decoration: none;
  color: #6e6b7b;
}
</style>

